// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext.jsx';

// const ProtectedRoute = ({ children }) => {
//   const { isAuthenticated, loading } = useAuth();

//   if (loading) {
//     return (
//       <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
//         <div className="spinner-border" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;


import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

/**
 * 🔧 DEV MODE FLAG
 * true  → all routes accessible (for development)
 * false → normal auth validation (for production)
 */
const DEV_BYPASS_AUTH = false;

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  // 🚀 DEV MODE: bypass authentication completely
  if (DEV_BYPASS_AUTH) {
    return children;
  }

  // ⏳ Loading state
  if (loading) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: '100vh' }}
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // 🔒 Not authenticated → redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Authenticated → render page
  return children;
};

export default ProtectedRoute;
